import {
  StoryblokServerComponent,
  storyblokEditable,
} from '@storyblok/react/rsc';
import { clsx } from 'clsx';
import { FC } from 'react';
import {
  ContentPageBlockStoryblok,
  ContentPageStoryblok,
} from 'storyblok-types';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';
import { ContentImage } from './ContentImage';
import styles from './styles.module.css';

const SMALL_DESKTOP_WIDTH = 1024;

export const ContentBlock: FC<
  IStoryBlokComponentProps<ContentPageStoryblok>
> = ({ blok }) => {
  const contentBlocks = blok.contentBlock as ContentPageBlockStoryblok[];

  return (
    <div className={styles.root} {...storyblokEditable(blok)}>
      <ContentImage
        className={styles.hero}
        src={blok.hero?.filename}
        width={SMALL_DESKTOP_WIDTH}
        alt={blok.hero?.alt}
      />
      {contentBlocks?.map((contentBlock) => {
        const isRichTextImageContainer = contentBlock?.contentBlocks?.every(
          (block) => block.component === 'richTextWithImage',
        );

        return (
          <div
            key={contentBlock._uid}
            className={clsx(
              styles.wrapper,
              contentBlock.hasBorder && styles.wrapperWithBorder,
              contentBlock?.backgroundColor?.color &&
                !isRichTextImageContainer &&
                styles.wrapperWithBackground,
              isRichTextImageContainer && styles.richTextImageContainer,
            )}
            style={{
              backgroundColor: isRichTextImageContainer
                ? ''
                : contentBlock?.backgroundColor?.color,
            }}
          >
            {contentBlock?.contentBlocks?.map((block) => {
              return <StoryblokServerComponent key={block._uid} blok={block} />;
            })}
          </div>
        );
      })}
    </div>
  );
};
